// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Button */

.button {
  display: inline-flex;

  column-gap: 0.3125em;
  align-items: center;
  justify-content: center;

  padding: 0.5em;
  margin: 0;

  font-family: var(--font-family-text);
  font-size: 0.875em;
  font-weight: 450;

  line-height: var(--font-line-ui);
  vertical-align: middle;

  color: var(--color-text-primary);

  -webkit-text-decoration: none;

  text-decoration: none;

  cursor: pointer;

  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;

  /* Primary */
}

.button[data-variant="primary"] {
    --csstools-light-dark-toggle-0785a194-0: var(--csstools-color-scheme--light) var(--color-black);
    color: var(--csstools-light-dark-toggle-0785a194-0, var(--color-white));
    --csstools-light-dark-toggle-0785a194-1: var(--csstools-color-scheme--light) var(--color-white);
    background-color: var(--csstools-light-dark-toggle-0785a194-1, var(--color-black));
  }

@supports (color: light-dark(red, red)) {
.button[data-variant="primary"] {
    color: light-dark(var(--color-white), var(--color-black));
    background-color: light-dark(var(--color-black), var(--color-white));
  }
}

.button[data-variant="primary"]:hover {
      --csstools-light-dark-toggle-0785a194-2: var(--csstools-color-scheme--light) var(--color-gray-60);
      background-color: var(--csstools-light-dark-toggle-0785a194-2, var(--color-gray-40));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="primary"]:hover {
      background-color: light-dark(var(--color-gray-40), var(--color-gray-60));
    }
}

.button[data-variant="primary"][data-action="positive"] {
      color: var(--color-white);
      --csstools-light-dark-toggle-0785a194-3: var(--csstools-color-scheme--light) var(--color-green-20);
      background-color: var(--csstools-light-dark-toggle-0785a194-3, var(--color-green-50));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="primary"][data-action="positive"] {
      background-color: light-dark(
        var(--color-green-50),
        var(--color-green-20)
      );
    }
}

.button[data-variant="primary"][data-action="positive"]:hover {
        --csstools-light-dark-toggle-0785a194-4: var(--csstools-color-scheme--light) var(--color-green-50);
        background-color: var(--csstools-light-dark-toggle-0785a194-4, var(--color-green-20));
      }

@supports (color: light-dark(red, red)) {
.button[data-variant="primary"][data-action="positive"]:hover {
        background-color: light-dark(
          var(--color-green-20),
          var(--color-green-50)
        );
      }
}

.button[data-variant="primary"][data-action="negative"] {
      color: var(--color-white);
      --csstools-light-dark-toggle-0785a194-5: var(--csstools-color-scheme--light) var(--color-red-20);
      background-color: var(--csstools-light-dark-toggle-0785a194-5, var(--color-red-50));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="primary"][data-action="negative"] {
      background-color: light-dark(var(--color-red-50), var(--color-red-20));
    }
}

.button[data-variant="primary"][data-action="negative"]:hover {
        --csstools-light-dark-toggle-0785a194-6: var(--csstools-color-scheme--light) var(--color-red-50);
        background-color: var(--csstools-light-dark-toggle-0785a194-6, var(--color-red-20));
      }

@supports (color: light-dark(red, red)) {
.button[data-variant="primary"][data-action="negative"]:hover {
        background-color: light-dark(var(--color-red-20), var(--color-red-50));
      }
}

/* Secondary */

.button[data-variant="secondary"] {
    border-color: currentcolor;
  }

.button[data-variant="secondary"]:hover {
      --csstools-light-dark-toggle-0785a194-7: var(--csstools-color-scheme--light) var(--color-gray-40);
      background-color: var(--csstools-light-dark-toggle-0785a194-7, var(--color-gray-80));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="secondary"]:hover {
      background-color: light-dark(var(--color-gray-80), var(--color-gray-40));
    }
}

.button[data-variant="secondary"][data-action="positive"] {
      --csstools-light-dark-toggle-0785a194-8: var(--csstools-color-scheme--light) var(--color-green-80);
      color: var(--csstools-light-dark-toggle-0785a194-8, var(--color-green-20));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="secondary"][data-action="positive"] {
      color: light-dark(var(--color-green-20), var(--color-green-80));
    }
}

.button[data-variant="secondary"][data-action="positive"]:hover {
        --csstools-light-dark-toggle-0785a194-9: var(--csstools-color-scheme--light) var(--color-green-20);
        background-color: var(--csstools-light-dark-toggle-0785a194-9, var(--color-green-90));
      }

@supports (color: light-dark(red, red)) {
.button[data-variant="secondary"][data-action="positive"]:hover {
        background-color: light-dark(
          var(--color-green-90),
          var(--color-green-20)
        );
      }
}

.button[data-variant="secondary"][data-action="negative"] {
      --csstools-light-dark-toggle-0785a194-10: var(--csstools-color-scheme--light) var(--color-red-80);
      color: var(--csstools-light-dark-toggle-0785a194-10, var(--color-red-50));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="secondary"][data-action="negative"] {
      color: light-dark(var(--color-red-50), var(--color-red-80));
    }
}

.button[data-variant="secondary"][data-action="negative"]:hover {
        --csstools-light-dark-toggle-0785a194-11: var(--csstools-color-scheme--light) var(--color-red-80);
        color: var(--csstools-light-dark-toggle-0785a194-11, var(--color-red-20));
        --csstools-light-dark-toggle-0785a194-12: var(--csstools-color-scheme--light) var(--color-red-10);
        background-color: var(--csstools-light-dark-toggle-0785a194-12, var(--color-red-90));
      }

@supports (color: light-dark(red, red)) {
.button[data-variant="secondary"][data-action="negative"]:hover {
        color: light-dark(var(--color-red-20), var(--color-red-80));
        background-color: light-dark(var(--color-red-90), var(--color-red-10));
      }
}

/* Plain */

.button[data-variant="plain"]:hover {
      --csstools-light-dark-toggle-0785a194-13: var(--csstools-color-scheme--light) var(--color-gray-40);
      background-color: var(--csstools-light-dark-toggle-0785a194-13, var(--color-gray-80));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="plain"]:hover {
      background-color: light-dark(var(--color-gray-80), var(--color-gray-40));
    }
}

.button[data-variant="plain"][data-action="positive"] {
      --csstools-light-dark-toggle-0785a194-14: var(--csstools-color-scheme--light) var(--color-green-80);
      color: var(--csstools-light-dark-toggle-0785a194-14, var(--color-green-20));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="plain"][data-action="positive"] {
      color: light-dark(var(--color-green-20), var(--color-green-80));
    }
}

.button[data-variant="plain"][data-action="positive"]:hover {
        --csstools-light-dark-toggle-0785a194-15: var(--csstools-color-scheme--light) var(--color-green-20);
        background-color: var(--csstools-light-dark-toggle-0785a194-15, var(--color-green-90));
      }

@supports (color: light-dark(red, red)) {
.button[data-variant="plain"][data-action="positive"]:hover {
        background-color: light-dark(
          var(--color-green-90),
          var(--color-green-20)
        );
      }
}

.button[data-variant="plain"][data-action="negative"] {
      --csstools-light-dark-toggle-0785a194-16: var(--csstools-color-scheme--light) var(--color-red-80);
      color: var(--csstools-light-dark-toggle-0785a194-16, var(--color-red-50));
    }

@supports (color: light-dark(red, red)) {
.button[data-variant="plain"][data-action="negative"] {
      color: light-dark(var(--color-red-50), var(--color-red-80));
    }
}

.button[data-variant="plain"][data-action="negative"]:hover {
        --csstools-light-dark-toggle-0785a194-17: var(--csstools-color-scheme--light) var(--color-red-80);
        color: var(--csstools-light-dark-toggle-0785a194-17, var(--color-red-20));
        --csstools-light-dark-toggle-0785a194-18: var(--csstools-color-scheme--light) var(--color-red-10);
        background-color: var(--csstools-light-dark-toggle-0785a194-18, var(--color-red-90));
      }

@supports (color: light-dark(red, red)) {
.button[data-variant="plain"][data-action="negative"]:hover {
        color: light-dark(var(--color-red-20), var(--color-red-80));
        background-color: light-dark(var(--color-red-90), var(--color-red-10));
      }
}

/* Disabled */

.button[disabled] {
    --csstools-light-dark-toggle-0785a194-19: var(--csstools-color-scheme--light) var(--color-gray-60) !important;
    color: var(--csstools-light-dark-toggle-0785a194-19, var(--color-gray-40)) !important;

    cursor: default;

    --csstools-light-dark-toggle-0785a194-20: var(--csstools-color-scheme--light) var(--color-gray-20) !important;

    background-color: var(--csstools-light-dark-toggle-0785a194-20, var(--color-gray-80)) !important;
    border-color: transparent;
  }

@supports (color: light-dark(red, red)) {
.button[disabled] {
    color: light-dark(var(--color-gray-40), var(--color-gray-60)) !important;

    background-color: light-dark(
      var(--color-gray-80),
      var(--color-gray-20)
    ) !important;
  }
}

/* Icon */

.button .icon {
    /* fix whitespace messing with layout */
    display: flex;
  }

.button svg {
    width: 1.25em;
    height: 1.25em;
  }

/* Label */

.button .label {
    padding-block: 0.125em;
    padding-inline: 0.0625em;
  }
`, "",{"version":3,"sources":["webpack://./components/button/server.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,oBAAoB;;EAEpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,cAAc;EACd,SAAS;;EAET,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;;EAEhB,gCAAgC;EAChC,sBAAsB;;EAEtB,gCAAgC;;EAEhC,6BAA6B;;EAE7B,qBAAqB;;EAErB,eAAe;;EAEf,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;;EAEtB,YAAY;AACd;;AAEA;IACI,+FAA+F;IAC/F,uEAAuE;IACvE,+FAA+F;IAC/F,kFAAkF;EACpF;;AAEF;AACA;IACI,yDAAyD;IACzD,oEAAoE;EACtE;AACF;;AAEA;MACM,iGAAiG;MACjG,oFAAoF;IACtF;;AAEJ;AACA;MACM,wEAAwE;IAC1E;AACJ;;AAEA;MACM,yBAAyB;MACzB,kGAAkG;MAClG,qFAAqF;IACvF;;AAEJ;AACA;MACM;;;OAGC;IACH;AACJ;;AAEA;QACQ,kGAAkG;QAClG,qFAAqF;MACvF;;AAEN;AACA;QACQ;;;SAGC;MACH;AACN;;AAEA;MACM,yBAAyB;MACzB,gGAAgG;MAChG,mFAAmF;IACrF;;AAEJ;AACA;MACM,sEAAsE;IACxE;AACJ;;AAEA;QACQ,gGAAgG;QAChG,mFAAmF;MACrF;;AAEN;AACA;QACQ,sEAAsE;MACxE;AACN;;AAEA,cAAc;;AAEd;IACI,0BAA0B;EAC5B;;AAEF;MACM,iGAAiG;MACjG,oFAAoF;IACtF;;AAEJ;AACA;MACM,wEAAwE;IAC1E;AACJ;;AAEA;MACM,kGAAkG;MAClG,0EAA0E;IAC5E;;AAEJ;AACA;MACM,+DAA+D;IACjE;AACJ;;AAEA;QACQ,kGAAkG;QAClG,qFAAqF;MACvF;;AAEN;AACA;QACQ;;;SAGC;MACH;AACN;;AAEA;MACM,iGAAiG;MACjG,yEAAyE;IAC3E;;AAEJ;AACA;MACM,2DAA2D;IAC7D;AACJ;;AAEA;QACQ,iGAAiG;QACjG,yEAAyE;QACzE,iGAAiG;QACjG,oFAAoF;MACtF;;AAEN;AACA;QACQ,2DAA2D;QAC3D,sEAAsE;MACxE;AACN;;AAEA,UAAU;;AAEV;MACM,kGAAkG;MAClG,qFAAqF;IACvF;;AAEJ;AACA;MACM,wEAAwE;IAC1E;AACJ;;AAEA;MACM,mGAAmG;MACnG,2EAA2E;IAC7E;;AAEJ;AACA;MACM,+DAA+D;IACjE;AACJ;;AAEA;QACQ,mGAAmG;QACnG,sFAAsF;MACxF;;AAEN;AACA;QACQ;;;SAGC;MACH;AACN;;AAEA;MACM,iGAAiG;MACjG,yEAAyE;IAC3E;;AAEJ;AACA;MACM,2DAA2D;IAC7D;AACJ;;AAEA;QACQ,iGAAiG;QACjG,yEAAyE;QACzE,iGAAiG;QACjG,oFAAoF;MACtF;;AAEN;AACA;QACQ,2DAA2D;QAC3D,sEAAsE;MACxE;AACN;;AAEA,aAAa;;AAEb;IACI,6GAA6G;IAC7G,qFAAqF;;IAErF,eAAe;;IAEf,6GAA6G;;IAE7G,gGAAgG;IAChG,yBAAyB;EAC3B;;AAEF;AACA;IACI,wEAAwE;;IAExE;;;gBAGY;EACd;AACF;;AAEA,SAAS;;AAET;IACI,uCAAuC;IACvC,aAAa;EACf;;AAEF;IACI,aAAa;IACb,cAAc;EAChB;;AAEF,UAAU;;AAEV;IACI,sBAAsB;IACtB,wBAAwB;EAC1B","sourcesContent":["/* Button */\n\n.button {\n  display: inline-flex;\n\n  column-gap: 0.3125em;\n  align-items: center;\n  justify-content: center;\n\n  padding: 0.5em;\n  margin: 0;\n\n  font-family: var(--font-family-text);\n  font-size: 0.875em;\n  font-weight: 450;\n\n  line-height: var(--font-line-ui);\n  vertical-align: middle;\n\n  color: var(--color-text-primary);\n\n  -webkit-text-decoration: none;\n\n  text-decoration: none;\n\n  cursor: pointer;\n\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n\n  /* Primary */\n}\n\n.button[data-variant=\"primary\"] {\n    --csstools-light-dark-toggle-0785a194-0: var(--csstools-color-scheme--light) var(--color-black);\n    color: var(--csstools-light-dark-toggle-0785a194-0, var(--color-white));\n    --csstools-light-dark-toggle-0785a194-1: var(--csstools-color-scheme--light) var(--color-white);\n    background-color: var(--csstools-light-dark-toggle-0785a194-1, var(--color-black));\n  }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"primary\"] {\n    color: light-dark(var(--color-white), var(--color-black));\n    background-color: light-dark(var(--color-black), var(--color-white));\n  }\n}\n\n.button[data-variant=\"primary\"]:hover {\n      --csstools-light-dark-toggle-0785a194-2: var(--csstools-color-scheme--light) var(--color-gray-60);\n      background-color: var(--csstools-light-dark-toggle-0785a194-2, var(--color-gray-40));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"primary\"]:hover {\n      background-color: light-dark(var(--color-gray-40), var(--color-gray-60));\n    }\n}\n\n.button[data-variant=\"primary\"][data-action=\"positive\"] {\n      color: var(--color-white);\n      --csstools-light-dark-toggle-0785a194-3: var(--csstools-color-scheme--light) var(--color-green-20);\n      background-color: var(--csstools-light-dark-toggle-0785a194-3, var(--color-green-50));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"primary\"][data-action=\"positive\"] {\n      background-color: light-dark(\n        var(--color-green-50),\n        var(--color-green-20)\n      );\n    }\n}\n\n.button[data-variant=\"primary\"][data-action=\"positive\"]:hover {\n        --csstools-light-dark-toggle-0785a194-4: var(--csstools-color-scheme--light) var(--color-green-50);\n        background-color: var(--csstools-light-dark-toggle-0785a194-4, var(--color-green-20));\n      }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"primary\"][data-action=\"positive\"]:hover {\n        background-color: light-dark(\n          var(--color-green-20),\n          var(--color-green-50)\n        );\n      }\n}\n\n.button[data-variant=\"primary\"][data-action=\"negative\"] {\n      color: var(--color-white);\n      --csstools-light-dark-toggle-0785a194-5: var(--csstools-color-scheme--light) var(--color-red-20);\n      background-color: var(--csstools-light-dark-toggle-0785a194-5, var(--color-red-50));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"primary\"][data-action=\"negative\"] {\n      background-color: light-dark(var(--color-red-50), var(--color-red-20));\n    }\n}\n\n.button[data-variant=\"primary\"][data-action=\"negative\"]:hover {\n        --csstools-light-dark-toggle-0785a194-6: var(--csstools-color-scheme--light) var(--color-red-50);\n        background-color: var(--csstools-light-dark-toggle-0785a194-6, var(--color-red-20));\n      }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"primary\"][data-action=\"negative\"]:hover {\n        background-color: light-dark(var(--color-red-20), var(--color-red-50));\n      }\n}\n\n/* Secondary */\n\n.button[data-variant=\"secondary\"] {\n    border-color: currentcolor;\n  }\n\n.button[data-variant=\"secondary\"]:hover {\n      --csstools-light-dark-toggle-0785a194-7: var(--csstools-color-scheme--light) var(--color-gray-40);\n      background-color: var(--csstools-light-dark-toggle-0785a194-7, var(--color-gray-80));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"secondary\"]:hover {\n      background-color: light-dark(var(--color-gray-80), var(--color-gray-40));\n    }\n}\n\n.button[data-variant=\"secondary\"][data-action=\"positive\"] {\n      --csstools-light-dark-toggle-0785a194-8: var(--csstools-color-scheme--light) var(--color-green-80);\n      color: var(--csstools-light-dark-toggle-0785a194-8, var(--color-green-20));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"secondary\"][data-action=\"positive\"] {\n      color: light-dark(var(--color-green-20), var(--color-green-80));\n    }\n}\n\n.button[data-variant=\"secondary\"][data-action=\"positive\"]:hover {\n        --csstools-light-dark-toggle-0785a194-9: var(--csstools-color-scheme--light) var(--color-green-20);\n        background-color: var(--csstools-light-dark-toggle-0785a194-9, var(--color-green-90));\n      }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"secondary\"][data-action=\"positive\"]:hover {\n        background-color: light-dark(\n          var(--color-green-90),\n          var(--color-green-20)\n        );\n      }\n}\n\n.button[data-variant=\"secondary\"][data-action=\"negative\"] {\n      --csstools-light-dark-toggle-0785a194-10: var(--csstools-color-scheme--light) var(--color-red-80);\n      color: var(--csstools-light-dark-toggle-0785a194-10, var(--color-red-50));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"secondary\"][data-action=\"negative\"] {\n      color: light-dark(var(--color-red-50), var(--color-red-80));\n    }\n}\n\n.button[data-variant=\"secondary\"][data-action=\"negative\"]:hover {\n        --csstools-light-dark-toggle-0785a194-11: var(--csstools-color-scheme--light) var(--color-red-80);\n        color: var(--csstools-light-dark-toggle-0785a194-11, var(--color-red-20));\n        --csstools-light-dark-toggle-0785a194-12: var(--csstools-color-scheme--light) var(--color-red-10);\n        background-color: var(--csstools-light-dark-toggle-0785a194-12, var(--color-red-90));\n      }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"secondary\"][data-action=\"negative\"]:hover {\n        color: light-dark(var(--color-red-20), var(--color-red-80));\n        background-color: light-dark(var(--color-red-90), var(--color-red-10));\n      }\n}\n\n/* Plain */\n\n.button[data-variant=\"plain\"]:hover {\n      --csstools-light-dark-toggle-0785a194-13: var(--csstools-color-scheme--light) var(--color-gray-40);\n      background-color: var(--csstools-light-dark-toggle-0785a194-13, var(--color-gray-80));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"plain\"]:hover {\n      background-color: light-dark(var(--color-gray-80), var(--color-gray-40));\n    }\n}\n\n.button[data-variant=\"plain\"][data-action=\"positive\"] {\n      --csstools-light-dark-toggle-0785a194-14: var(--csstools-color-scheme--light) var(--color-green-80);\n      color: var(--csstools-light-dark-toggle-0785a194-14, var(--color-green-20));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"plain\"][data-action=\"positive\"] {\n      color: light-dark(var(--color-green-20), var(--color-green-80));\n    }\n}\n\n.button[data-variant=\"plain\"][data-action=\"positive\"]:hover {\n        --csstools-light-dark-toggle-0785a194-15: var(--csstools-color-scheme--light) var(--color-green-20);\n        background-color: var(--csstools-light-dark-toggle-0785a194-15, var(--color-green-90));\n      }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"plain\"][data-action=\"positive\"]:hover {\n        background-color: light-dark(\n          var(--color-green-90),\n          var(--color-green-20)\n        );\n      }\n}\n\n.button[data-variant=\"plain\"][data-action=\"negative\"] {\n      --csstools-light-dark-toggle-0785a194-16: var(--csstools-color-scheme--light) var(--color-red-80);\n      color: var(--csstools-light-dark-toggle-0785a194-16, var(--color-red-50));\n    }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"plain\"][data-action=\"negative\"] {\n      color: light-dark(var(--color-red-50), var(--color-red-80));\n    }\n}\n\n.button[data-variant=\"plain\"][data-action=\"negative\"]:hover {\n        --csstools-light-dark-toggle-0785a194-17: var(--csstools-color-scheme--light) var(--color-red-80);\n        color: var(--csstools-light-dark-toggle-0785a194-17, var(--color-red-20));\n        --csstools-light-dark-toggle-0785a194-18: var(--csstools-color-scheme--light) var(--color-red-10);\n        background-color: var(--csstools-light-dark-toggle-0785a194-18, var(--color-red-90));\n      }\n\n@supports (color: light-dark(red, red)) {\n.button[data-variant=\"plain\"][data-action=\"negative\"]:hover {\n        color: light-dark(var(--color-red-20), var(--color-red-80));\n        background-color: light-dark(var(--color-red-90), var(--color-red-10));\n      }\n}\n\n/* Disabled */\n\n.button[disabled] {\n    --csstools-light-dark-toggle-0785a194-19: var(--csstools-color-scheme--light) var(--color-gray-60) !important;\n    color: var(--csstools-light-dark-toggle-0785a194-19, var(--color-gray-40)) !important;\n\n    cursor: default;\n\n    --csstools-light-dark-toggle-0785a194-20: var(--csstools-color-scheme--light) var(--color-gray-20) !important;\n\n    background-color: var(--csstools-light-dark-toggle-0785a194-20, var(--color-gray-80)) !important;\n    border-color: transparent;\n  }\n\n@supports (color: light-dark(red, red)) {\n.button[disabled] {\n    color: light-dark(var(--color-gray-40), var(--color-gray-60)) !important;\n\n    background-color: light-dark(\n      var(--color-gray-80),\n      var(--color-gray-20)\n    ) !important;\n  }\n}\n\n/* Icon */\n\n.button .icon {\n    /* fix whitespace messing with layout */\n    display: flex;\n  }\n\n.button svg {\n    width: 1.25em;\n    height: 1.25em;\n  }\n\n/* Label */\n\n.button .label {\n    padding-block: 0.125em;\n    padding-inline: 0.0625em;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
